import { Component, OnInit } from '@angular/core';
import { ElementTypeCategoriesDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import { asEnumerable } from 'linq-es2015';
import { LocalizationHelperService } from '../../../shared/localization/localization-helper.service';

type TMetadata = ElementTypeCategoriesDto;

const COMPONENT_SELECTOR = 'wlm-layer-tooltip';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './layer-tooltip.component.html',
    styleUrls: ['./layer-tooltip.component.scss'],
    standalone: false
})
export class LayerTooltipComponent implements OnInit {
  tooltipProperties: any[];
  metadata: Map<string, TMetadata[]>;
  metadataKey: string;
  tooltipPropertyValues: any;
  elementType: string;

  title: string;
  subtitle: string;

  readonly T_SCOPE = `${AppModules.Map}.${COMPONENT_SELECTOR}`;

  constructor(private _localization: LocalizationHelperService) {}

  ngOnInit(): void {
    const metadataByKey: TMetadata[] = this.metadata[this.metadataKey];

    if (!metadataByKey?.length) {
      return;
    }

    const metadataIsWeb = asEnumerable(metadataByKey)
      .Where((x) => x.type === this.elementType)
      .SelectMany((x) =>
        asEnumerable(x.categories).SelectMany((x) =>
          asEnumerable(x.attributes).Where((x) => x.isWeb)
        )
      )
      .ToArray();

    const mapTooltipProperties = [];

    metadataIsWeb.forEach((attribute) => {
      const value = this.tooltipPropertyValues[attribute.name];
      const formatted = this._localization.formatAttributeValue(
        value,
        attribute.format,
        attribute.units
      );
      if (value) {
        mapTooltipProperties.push({
          key: attribute.alias,
          value: formatted,
        });
      }
    });

    this.tooltipProperties = mapTooltipProperties;
  }
}
